module.exports = __webpack_public_path__ + "static/media/logo.042b6845.svg";